var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-chip",
    _vm._g(
      _vm._b(
        {
          attrs: {
            color: _vm.color,
            outlined: _vm.outlined,
            "x-small": _vm.xSmall,
            small: _vm.small,
            dark: _vm.dark,
            close: _vm.closable
          },
          on: { "click:close": _vm.onClose }
        },
        "v-chip",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [_vm._t("default", [_vm._v(_vm._s(_vm.text))])],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }